export default __webpack_public_path__ + "static/media/HCP_Website_Animation.70b17c7c.mp4";